module.exports = __webpack_public_path__ + "img/Manual Exam Upload - Gray.d8ccc332.png";